import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoMetaTags } from '../../../models/seoMetaTags';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-error-page-404',
  standalone: true,
  imports: [],
  templateUrl: './error-page-404.component.html',
  styleUrl: './error-page-404.component.css'
})
export class ErrorPage404Component implements OnInit {
  seotags: SeoMetaTags = new SeoMetaTags()
  constructor(
    public router: Router,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document
  ) { }
  ngOnInit(): void {
    this.seotags.pageUrl = '';
    this.setSeoMetaTags(this.seotags);
  }
  navigate() {
    this.router.navigate(["/"]);
  }
  setSeoMetaTags(seoMetaTags: SeoMetaTags) {
    const pageTitle = seoMetaTags.pageTitle;
    const pageDescription = seoMetaTags.pageDescription;
    const pageUrl = seoMetaTags.pageUrl;
    const pageImage = seoMetaTags.pageImage;

    // Title
    this.titleService.setTitle(pageTitle);

    // Description
    this.metaService.updateTag({
      name: 'robots',
      content: "noindex,follow"
    });

    // Open Graph
    this.metaService.updateTag({
      property: 'og:title',
      content: pageTitle
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: pageDescription
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: pageUrl
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: pageImage
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website'
    });

    // ✅ Twitter Tags
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content: pageTitle
    });

    this.metaService.updateTag({
      name: 'twitter:description',
      content: pageDescription
    });

    this.metaService.updateTag({
      name: 'twitter:image',
      content: pageImage
    });

    this.metaService.updateTag({
      name: 'twitter:url',
      content: pageUrl
    });

    // (Optional but recommended)
    // this.metaService.updateTag({
    //   name: 'twitter:site',
    //   content: '@yourTwitterHandle'
    // });

    // this.metaService.updateTag({
    //   name: 'twitter:creator',
    //   content: '@yourTwitterHandle'
    // });

    // Canonical
    this.setCanonicalURL(pageUrl);
  }

  setCanonicalURL(url: string) {
    let link: HTMLLinkElement | null =
      this.document.querySelector("link[rel='canonical']");
    if (!url) {
      if (link) {
        this.document.head.removeChild(link);
      }
      return;
    }
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.document.head.appendChild(link);
    }
  }
}
